import { Directive, HostBinding, Input } from '@angular/core';
import { ThasEventType } from '@thiememeulenhoff/analytics-service-client';
import { AttributeDirective } from './attribute.directive';

@Directive({
  selector: '[thasMedia]',
})
export class MediaDirective extends AttributeDirective {
  protected readonly type = ThasEventType.Media;

  @Input('thasMedia')
  @HostBinding('attr.data-thas-media')
  public value?: string;
}
